import Image from 'next/image'
import React from 'react'

type InterviewMainImageProps = {
  imgUrl: string
  mobileImgUrl: string
  imgAlt?: string
  message: string
  textBottomPos?: string
}

const InterviewMainImage: React.FC<InterviewMainImageProps> = ({
  imgUrl,
  imgAlt,
  mobileImgUrl,
  message,
  textBottomPos,
}) => {
  return (
    <>
      <div className="relative">
        <div className="sp:hidden mt-20">
          <pre className="interview_head_text" style={{ bottom: textBottomPos }}>
            {message}
          </pre>
          <Image
            className="LP_head "
            src={imgUrl}
            alt={imgAlt}
            width={1150}
            height={420}
            layout="raw"
          />
        </div>
        <div className="pc:hidden mt-16 ">
          <pre className="interview_head_text_sp">{message}</pre>
          <Image
            className="LP_head w-full"
            src={mobileImgUrl}
            alt={imgAlt}
            width={670}
            height={720}
            layout="raw"
          />
        </div>
      </div>
    </>
  )
}

export default InterviewMainImage
